<div class="login">

  <!-- Right panel: status -->
  <div class="login__panel login__panel--right">
    <div class="login-form">

      <div class="login-form__field">
        <h2 class="login-form__label">Check your email</h2>
        <p class="login-form__hint">
          We've sent a confirmation link to <strong>{{ email }}</strong>. Click it to activate
          your account, then come back and sign in.
        </p>
      </div>

      <div class="login-form__actions">
        <button
          class="btn btn--primary"
          type="button"
          [disabled]="isResending || resendCooldown > 0"
          (click)="resend()"
        >
          {{ resendCooldown > 0 ? 'Resend available in ' + resendCooldown + 's' : 'Resend confirmation email' }}
        </button>
        <p class="login-form__footer">
          Already confirmed? <a routerLink="/login" class="link">Sign in</a>
        </p>
      </div>

    </div>
  </div>

  <!-- Left panel: branding mosaic -->
  <div class="login__panel login__panel--left">
    <app-auth-panel></app-auth-panel>
  </div>

</div>
